import '../styles.css';

import { Link } from 'react-router-dom';

import gallery_img_6 from '../assets/gallery_imgs/gallery_img_6.jpeg';
import gallery_img_8 from '../assets/gallery_imgs/gallery_img_8.jpeg';
import cookiesPicture from '../assets/cookies.jpg';
// import gallery_img_1 from '../assets/gallery_imgs/gallery_img_1.jpeg';
// import gallery_img_2 from '../assets/gallery_imgs/gallery_img_2.jpeg';
// import gallery_img_3 from '../assets/gallery_imgs/gallery_img_3.jpeg';

import Button from 'react-bootstrap/Button';

// import Carousel from 'react-bootstrap/Carousel';

function HomePage() {
	return (
		<div className="homePage">
			<div className="homePage-section1">
				<h1>
					‘Alone we can do so little; together we can do
					so much’
				</h1>

				<p className="homePage-section1_paragraph">
					Helen Keller
				</p>
			</div>

			<div className="homePage-section2">
				<h2>About Us</h2>

				<div className="homePage-section2_subsection">
					<img
						src={gallery_img_6}
						alt="team"
						className="homePage-section2_subsection_img"
					/>

					<p className="homePage-section2_subsection_txt">
						Our goal is to mobilize transgenerational
						communities of global citizens to build a
						tolerant and sustainable world for our
						future
						<br />
						<Link to="/about-us">
							<Button className="homepage-section2_buttonlink">
								Learn More
							</Button>
						</Link>
					</p>
				</div>

				<div className="homePage-section2_subsection_2">
					<p className="homePage-section2_subsection_txt">
						APL WIN is an initiative taken by a group
						of high school students who have a passion
						for bringing change to the world. We, as
						the future generation, are slowly realizing
						the flaws and problems of our society and
						wish to bring equality to the world at
						large
						<br />
						<Link to="/about-us">
							<Button className="homepage-section2_buttonlink">
								Learn More
							</Button>
						</Link>
					</p>

					<img
						src={gallery_img_8}
						alt="team"
						className="homePage-section2_subsection_img"
					/>
				</div>

				<div className="homePage-section2_subsection_responsive">
					<img
						src={gallery_img_8}
						alt="team"
						className="homePage-section2_subsection_img"
					/>

					<p className="homePage-section2_subsection_txt">
						APL GIN is an initiative taken by a group
						of high school students who have a passion
						for bringing change to the world. We, as
						the future generation, are slowly realizing
						the flaws and problems of our society and
						wish to bring equality to the world at
						large
						<br />
						<Link to="/about-us">
							<Button className="homepage-section2_buttonlink">
								Learn More
							</Button>
						</Link>
					</p>
				</div>
			</div>

			<div className="homePage-section3">
				<h2>Events</h2>

				<div className="homePage-section3_subsection">
					<h3>APL Global Cultural Evening Bake Sale</h3>
					<div className="homePage-section2_subsection">
						<img
							src={cookiesPicture}
							alt="cookies"
							width={250}
							height={400}
						/>

						<p className="homePage-section2_subsection_txt">
							APL WIN conducted a bake sale on the
							6th of August in APL Global School,
							Thoraipakkam, Tamil Nadu, to raise
							funds for the{' '}
							<a
								href="https://www.balamandir.org/site/"
								target="_blank"
								rel="noopener noreferrer"
							>
								{' '}
								Bala Mandir Kamaraj Trust
							</a>
							<br />
							<Link to="/events">
								<Button className="homepage-section2_buttonlink">
									Find Out More
								</Button>
							</Link>
						</p>
					</div>
				</div>
			</div>

			{/* <div className="homePage-section4">
				<h2>Gallery</h2>

				<Carousel
					className="homePage-section4_carousel"
					variant="light"
				>
					<Carousel.Item>
						<img
							className="d-block w-100 carousel_img"
							src={gallery_img_1}
							alt="First slide"
						/>
					</Carousel.Item>
					<Carousel.Item>
						<img
							className="d-block w-100 carousel_img"
							src={gallery_img_2}
							alt="Second slide"
						/>
					</Carousel.Item>
					<Carousel.Item>
						<img
							className="d-block w-100 carousel_img"
							src={gallery_img_3}
							alt="Third slide"
						/>
					</Carousel.Item>
				</Carousel>

				<Link to="/gallery">
					<Button className="homepage-section2_buttonlink">
						View More
					</Button>
				</Link>
			</div> */}
		</div>
	);
}

export default HomePage;
